// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"zo-z","breadcrumbForward":"Ao-z","breadcrumbBack":"Bo-z","selected":"Co-z"};